import {fsa, fsaPayload, fsaPayloadByKeys} from './helpers'

export const FEATURED_REVIEWS_OK = 'featured reviews fetch success'
export const featuredReviewsOk = fsaPayload(FEATURED_REVIEWS_OK)

export const FEATURED_REVIEWS_NOT_OK = 'featured reviews fetch fail'
export const featuredReviewsNotOk = fsaPayload(FEATURED_REVIEWS_NOT_OK)

export const PRODUCT_REVIEWS_OK = 'PRODUCT_REVIEWS_OK'
export const productReviewsOk = fsaPayload(PRODUCT_REVIEWS_OK)

export const PRODUCT_REVIEWS_NOT_OK = 'PRODUCT_REVIEWS_NOT_OK'
export const productReviewsNotOk = fsaPayload(PRODUCT_REVIEWS_NOT_OK)

export const PRODUCT_REVIEWS_PAGINATION_OK = 'PRODUCT_REVIEWS_PAGINATION_OK'
export const productReviewsPaginationOk = fsaPayload(PRODUCT_REVIEWS_PAGINATION_OK)

export const PAGINATION_CHANGE_PAGE = 'reviews/pagination change page'
export const paginationChangePage = fsaPayloadByKeys(PAGINATION_CHANGE_PAGE, ['index'])

export const PAGINATION_NEXT_PAGE = 'reviews/next page'
export const paginationNextPage = fsa(PAGINATION_NEXT_PAGE)

export const PAGINATION_PREV_PAGE = 'reviews/previous page'
export const paginationPrevPage = fsa(PAGINATION_PREV_PAGE)

export const PAGINATION_FIRST_PAGE = 'reviews/first page'
export const paginationFirstPage = fsa(PAGINATION_FIRST_PAGE)

export const PAGINATION_LAST_PAGE = 'reviews/last page'
export const paginationLastPage = fsa(PAGINATION_LAST_PAGE)

export const OPEN_REVIEW_IMAGE_MODAL = 'open review image modal'
export const openReviewImageModal = fsaPayload(OPEN_REVIEW_IMAGE_MODAL)

export const CLOSE_REVIEW_IMAGE_MODAL = 'close review image modal'
export const closeReviewImageModal = fsa(CLOSE_REVIEW_IMAGE_MODAL)

export const FILTER_REVIEWS_BY_EVENT = 'filter reviews by given event type'
export const filterReviewsByEvent = fsaPayload(FILTER_REVIEWS_BY_EVENT)

export const FILTER_REVIEWS_BY_SCORE = 'filter reviews by given score'
export const filterReviewsByScore = fsaPayload(FILTER_REVIEWS_BY_SCORE)

export const OPEN_REVIEWS_FILTER_MODAL = 'open reviews filter modal for mobile'
export const openReviewsFilterModal = fsa(OPEN_REVIEWS_FILTER_MODAL)

export const CLOSE_REVIEWS_FILTER_MODAL = 'close reviews filter modal for mobile'
export const closeReviewsFilterModal = fsa(CLOSE_REVIEWS_FILTER_MODAL)

export const ELEMENT_IS_SCROLL_READY = 'element is ready to be anchored to'
export const elementIsScrollReady = fsa(ELEMENT_IS_SCROLL_READY)

export const RESET_CURRENT_PAGE_INDEX = 'reset current page index back to first page'
export const resetCurrentPageIndex = fsa(RESET_CURRENT_PAGE_INDEX)

export const RESET_REVIEWS_FILTER = 'reset review filters to all'
export const resetReviewsFilter = fsa(RESET_REVIEWS_FILTER)

export const OPEN_EVENT_FILTER_DROPDOWN = 'open event filters drop down'
export const openEventFilterDropdown = fsa(OPEN_EVENT_FILTER_DROPDOWN)

export const CLOSE_EVENT_FILTER_DROPDOWN = 'close event filters drop down'
export const closeEventFilterDropdown = fsa(CLOSE_EVENT_FILTER_DROPDOWN)

export const FEATURED_REVIEWS_LOADED = 'featured reviews has loaded'
export const featuredReviewsLoaded = fsa(FEATURED_REVIEWS_LOADED)

export const FEATURED_REVIEWS_UNLOADED = 'featured reviews has unloaded'
export const featuredReviewsUnloaded = fsa(FEATURED_REVIEWS_UNLOADED)

export const CLEAR_REVIEWS = 'clear all reviews'
export const clearReviews = fsa(CLEAR_REVIEWS)

export const OPEN_SCORE_FILTER_DROPDOWN = 'open score filter dropdown'
export const openScoreFilterDropdown = fsa(OPEN_SCORE_FILTER_DROPDOWN)

export const CLOSE_SCORE_FILTER_DROPDOWN = 'close score filter dropdown'
export const closeScoreFilterDropdown = fsa(CLOSE_SCORE_FILTER_DROPDOWN)

export const DISPLAY_FEATURED_REVIEWS = 'reviews/display featured'
export const displayFeaturedReviews = fsaPayloadByKeys(DISPLAY_FEATURED_REVIEWS, ['productId'])

export const DISPLAY_ALL_REVIEWS = 'reviews/display all'
export const displayAllReviews = fsaPayloadByKeys(DISPLAY_ALL_REVIEWS, ['productSlug'])
